<template>
  <!-- 素材详情页 -->
  <div class="Materialdetailspage">
    <div class="box">
      <h4 class="h4size" style="color: #000; cursor: pointer">
        当前位置: <span @click="homes">首页</span> >
        <span @click="myinformation">素材下载</span> > {{ tepname.scmc }}
      </h4>
      <div class="details">
        <div class="details-left">
          <div class="imgtu">
            <div class="demo-image__preview">
              <video v-if="tepname.wjgs === '视频'" :src="url" controls></video>
              <el-image
                v-if="tepname.wjgs === '图片' || tepname.wjgs === '动图'"
                :src="url"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </div>
          <div class="pfname">
            <h5>{{ tepname.scmc }}</h5>
            <div class="pfjp">
              <img src="../../assets/medal.png" alt="" />
              <span v-if="tepname.pf !== ''">{{ tepname.pf }}</span>
              <span v-if="tepname.pf == null">5</span>
              <div class="block">
                <span style="margin-right: 10px" class="demonstration"
                  >我的评分</span
                >
                <el-rate @change="insratescis()" v-model="value1"></el-rate>
              </div>
            </div>
          </div>
        </div>
        <div class="details-right">
          <div class="right-top">
            <!-- <a href="javascript:;" class="down_btn_a"  :download='url'>点击下载</a> -->
            <!-- <a href=""  :download='url'>1111111111</a> -->

            <!-- <el-button @click="downloadByBlob(url,tepname.scmc)">立即下载</el-button> -->

            <div
              class="right-top-x"
              :style="{ color: scscys ? '#4CCAFF' : '#999999' }"
              @click="inssccollectZ(tepname.id)"
            >
              <i class="iconfont gos-mn_shoucang_fill lheight"></i>
              {{ tepname.sc }}
            </div>
            <div class="right-top-y">
              <i class="iconfont gos-yanjing1 lheight"></i> {{ tepname.ll }}
            </div>
          </div>
          <h4>素材信息</h4>
          <p class="nameofthe">素材名称：{{ tepname.scmc }}</p>
          <p class="nameofthe">素材格式：{{ tepname.scgs }}</p>
          <p class="nameofthe">素材尺寸：{{ tepname.sccc }}</p>
          <p class="nameofthe">上传时间：{{ tepname.materialtime }}</p>
          <h4 style="margin-top: 20px">上传用户</h4>
          <div class="imgsd">
            <img
              style="width: 17px; height: 19px; border-radius: 50%"
              :src="http + tepname.tx"
              alt=""
            />
            <span>
              {{ tepname.name }} &nbsp;
              {{ tepname.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") }}
            </span>
          </div>
          <h4>素材声明</h4>
          <p class="clsm">
            部分素材为用户免费上传，若发现您的权利被侵害，
            请点击后方举报按钮进行投诉，我们尽快处理。
          </p>
          <div
            style="
              font-size: 13px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #4ccaff;
              line-height: 23px;
            "
          >
            <i class="iconfont gos-jubao"> </i>
            &nbsp; 举报请拨打客服电话：010-6290-6806
          </div>
          <!-- <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose">
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

  <el-form-item label="举报理由" prop="type">
    <el-checkbox-group v-model="ruleForm.type">
      <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
      <el-checkbox label="地推活动"     name="type"></el-checkbox>
      <el-checkbox label="线下主题活动" name="type"></el-checkbox>
      <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
    </el-checkbox-group>
  </el-form-item>

  <el-form-item label="其它问题" prop="desc">
    <el-input type="textarea" v-model="ruleForm.desc"></el-input>
  </el-form-item>

      <el-form-item label="联系方式" prop="name">
    <el-input v-model="ruleForm.name"></el-input>
  </el-form-item>

</el-form>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    <el-button @click="resetForm('ruleForm'),dialogVisible = false">重置</el-button>
                </span>
                </el-dialog> -->
        </div>
      </div>
      <h5 class="hss5">相关推荐</h5>
      <div class="pbbu">
        <ul>
          <li class="Live1" v-for="item in tepsdsas" :key="item.id">
            <div
              @click="detailspage(item.id)"
              style="width: 247px; height: 151px"
              class="Figuremove"
            >
              <img
                style="width: 247px; object-fit: contain; height: 151px"
                v-if="item.wjgs == '图片' || item.wjgs == '动图'"
                :src="http + item.scwj"
                alt=""
              />
              <video
                style="width: 247px; height: 151px"
                v-if="item.wjgs == '视频'"
                :src="http + item.scwj"
              ></video>
            </div>
            <div class="Thetitle">
              <div class="Thetitle-top">
                <p @click="detailspage(item.id)">
                  {{ item.scmc }}
                </p>
                <span @click="detailspage(item.id)">{{ item.wjgs }}</span>
              </div>
              <div class="Thetitle-center">
                <span class="Thetitle-jg">{{ item.sfff }}</span>
                <span>
                  <i class="iconfont gos-aixin xinx"></i> {{ item.sc }}</span
                >
              </div>
              <div class="Thetitle-bottom">
                <div class="Photoname">
                  <img :src="http + item.tx" alt="" />
                  <span>
                    {{ item.name }}
                  </span>
                </div>
                <el-button @click="detailspage(item.id)">立即查看</el-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="burroms">
        <el-button @click="Toviewmore()">查看更多</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  selmaterial,
  insratesc,
  selratesc,
  inssccollect,
  selsccollect,
} from "../../api/patient";
export default {
  data() {
    return {
      // 收藏装填
      tepsdsas: {},
      scscys: false,
      http: this.$store.state.https,
      value: "",
      tepname: {},
      dialogVisible: false,
      ruleForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      value1: 0,
      //  图片预览
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      srcList: [],
      rules: {},
    };
  },
  async created() {
    await this.selmaterialis();
    await this.ynxgssss();
  },
  methods: {
    homes() {
      this.$router.push("/home");
    },
    myinformation() {
      this.$router.push("/materialpage");
    },
    // 查看跟多
    Toviewmore() {
      this.$store.commit("Stateofthe1", this.tepname);
      this.$router.push("/materialpage");
    },
    // 素材详情
    async detailspage(item) {
      await this.$store.commit("sucaixingqi", item);
      await this.selmaterialis();
      window.scrollTo({
        top: 1,
      });
    },
    async ynxgssss() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 8);
      data.append("sort", this.tepname.sort);
      data.append("jg", this.tepname.sfff);
      data.append("px", "浏览倒");
      data.append("wjgs", this.tepname.wjgs);
      data.append("status", "已通过");
      await selmaterial(data).then((res) => {
        this.tepsdsas = res.rows;
      });
    },
    //  用户获取该素材的收藏状态
    selsccollect() {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("itemid", this.tepname.id);
        data.append("userid", this.$store.state.user.id);
        selsccollect(data).then((res) => {
          if (res === "") {
            this.scscys = false;
          } else {
            this.scscys = true;
          }
        });
      }
    },
    // 素材收藏
    inssccollectZ(item) {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("itemid", item);
        data.append("userid", this.$store.state.user.id);
        inssccollect(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
          }
          this.selmaterialis();
        });
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 获取评分
    selratescis() {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("itemid", this.$store.state.sucaixi);
        data.append("userid", this.$store.state.user.id);
        selratesc(data).then((res) => {
          this.value1 = res.rate;
        });
      }
    },
    // 素材评分
    insratescis() {
      if (this.$store.state.isLogin) {
        var data = new FormData();
        data.append("itemid", this.tepname.id);
        data.append("userid", this.$store.state.user.id);
        data.append("rate", this.value1);
        insratesc(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.selmaterialis();
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    // 保存举报
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    dialogVisib() {
      this.dialogVisible = true;
    },
    // 素材详情信息
    async selmaterialis() {
      var data = new FormData();
      data.append("id", this.$store.state.sucaixi);
      if (this.$store.state.isLogin) {
        data.append("userid", this.$store.state.user.id);
      }
      await selmaterial(data).then((res) => {
        this.tepname = res;
        this.url = this.http + res.scwj;
        this.srcList.push(this.url);
        // this.value1 = Number(res.pf)
        this.selsccollect();
      });
      this.selratescis();
    },
    downloadByBlob(url, name) {
      // window.open(this.url)
      // window.location.href = this.url
      // const image = new Image()
      // image.setAttribute('crossOrigin', 'anonymous')
      // image.src = url
      // image.onload = () => {
      //   const canvas = document.createElement('canvas')
      //   canvas.width = image.width
      //   canvas.height = image.height
      //   const ctx = canvas.getContext('2d')
      //   ctx.drawImage(image, 0, 0, image.width, image.height)
      //   canvas.toBlob((blob) => {
      //     const url = URL.createObjectURL(blob)
      //     this.download(url, name)
      //     // 用完释放URL对象
      //     URL.revokeObjectURL(url)
      //   })
      // }
    },
    download(href, name) {
      const eleLink = document.createElement("a");
      eleLink.download = name;
      eleLink.href = href;
      eleLink.click();
      eleLink.remove();
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.Materialdetailspage {
  box-shadow: 0px 0px 3px 4px rgba(6, 0, 1, 0.07);
  margin-top: 4px;
  background: #fff;
  padding-top: 4px;
  padding-bottom: 88px;
  text-align: left;
  .box {
    width: 1090px;
    margin: auto;
    padding: 0 25px;
    // min-height: 1200px;
    .h4size {
      margin-top: 20px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #bdbdbd;
    }
    .details {
      display: flex;
      margin-top: 30px;
      .details-left {
        margin-right: 25px;
        width: 678px;
        height: 434px;
        background: #ffffff;
        border: 1px solid #ededed;
        .imgtu {
          width: 646px;
          height: 363px;
          background: #f6f6f6;
          margin: 0 auto;
          line-height: 363px;
          margin-top: 16px;
          .demo-image__preview {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            // padding-top: 10px;
            video {
              width: 100%;
              height: 100%;
            }
            .el-image {
              width: 100%;
              height: 347px;
              margin-top: 8px;
              ::v-deep .el-image__inner {
                object-fit: contain;
              }
            }
          }
        }
        .pfname {
          margin: 15px 0px 0px 19px;
          display: flex;
          line-height: 24px;
          .pfjp {
            margin-left: 10px;
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #f86626;
            display: flex;
            img {
              width: 19px;
              height: 24px;
              margin-right: 10px;
              position: relative;
              top: 1px;
            }
            span {
              height: 29px;
            }
            .block {
              margin-left: 70px;
              display: flex;
            }
          }
        }
        h5 {
          min-width: 300px;
          line-height: 30px;

          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }
      }
      .details-right {
        padding: 15px;
        width: 347px;
        // height: 434px;
        background: #ffffff;
        border: 1px solid #ededed;
        .right-top {
          display: flex;
          height: 28px;
          .el-button {
            padding: 0px;
            width: 99px;
            height: 28px;
            background: #4ccaff;
            border-radius: 6px;
            background: #4ccaff;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            border-color: #4ccaff;
          }

          .el-button:hover {
            background: #4ccaffc9;
          }
          .right-top-x {
            color: #999999;
            line-height: 28px;
            // margin-left: 27px;
            margin-right: 25px;
            .lheight {
              position: relative;
              top: 2px;
            }
          }
          .scsadsa {
            color: #4ccaff;
            line-height: 28px;
            margin-left: 27px;
            margin-right: 25px;
            .lheight {
              position: relative;
              top: 2px;
            }
          }
          .right-top-y {
            color: #999999;
            line-height: 28px;
            .lheight {
              position: relative;
              top: 2px;
            }
          }
        }
        h4 {
          height: 15px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-top: 25px;
          margin-bottom: 19px;
        }
        .nameofthe {
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 23px;
          margin-bottom: 2px;
        }
        .imgsd {
          .img {
            width: 19px;
            height: 19px;
            border-radius: 50%;
          }
          span {
            margin-left: 10px;
            font-size: 13px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 23px;
          }
        }
        .clsm {
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 23px;
          font-size: 13px;
        }
      }
    }
    .hss5 {
      height: 22px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      margin-top: 25px;
      margin-bottom: 18px;
    }
  }
}
#images {
  img {
    max-width: 646px;
    max-height: 363px;
  }
}
.pbbu {
  text-align: left;
  margin-top: 50px;
  min-height: 550px;
  ul {
    display: flex;
    flex-wrap: wrap;
    // padding: 0 15px;
    li {
      width: 247px;
      height: 265px;
      background: #ffffff;
      border: 1px solid #f6f6f6;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.22);
      border-radius: 6px;
      margin-bottom: 20px;
      margin-right: 8px;
      margin-left: 8px;
      transition: all 0.2s;
      .Thetitle {
        // display: flex;
        padding: 9px 20px 0px 20px;
        // margin-top: 10px;
        // justify-content: space-between;
        // width: 213px;
        .Thetitle-top {
          display: flex;
          justify-content: space-between;
          p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            width: 150px;
            height: 18px;
            display: -webkit-box; /**对象作为伸缩盒子模型展示**/
            -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
            -webkit-line-clamp: 1; /**显示的行数**/
            overflow: hidden; /**隐藏超出的内容**/
          }
          span {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
  }
}
.Thetitle-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 11px;
  border-top: 1px solid #f6f6f6;
  padding: 10px 0;
  .Photoname {
    display: flex;
    img {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      // width: 300px;
      width: 120px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
  .el-button--default {
    padding: 0px;
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #ffffff;
    width: 67px;
    height: 23px;
    background: #4ccaff;
    border-radius: 4px;
  }
  .el-button:active {
    border-color: #4ccaff;
  }
  .el-button:hover {
    background: #4ccaffc9;
  }
}
.Thetitle-center {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  .Thetitle-jg {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ff1616;
  }
  .xinx {
    width: 12px;
    height: 11px;
    color: #999999;
    margin-right: 5px;
  }
}
.burroms {
  text-align: center;
  .el-button {
    width: 99px;
    height: 28px;
    padding: 0px;
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    background: #4ccaff;
    border-radius: 4px;
    color: #fff;
  }
  .el-button:active {
    border-color: #4ccaff;
  }
  .el-button:hover {
    background: #4ccaffc9;
  }
}
.demonstration {
  height: 13px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.h4size {
  color: #000;
}
// 适配手机端
@media (max-width: 768px) {
  .Materialdetailspage {
    .box {
      width: 95vw;
      padding: 10px;
      .details {
        display: block;
        margin-left: 0px;
        .details-left {
          margin-right: 0px;
          width: 95vw;
          .imgtu {
            width: 95vw;
            .demo-image__preview {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              // padding-top: 10px;
              video {
                width: 100%;
                height: 100%;
              }
              .el-image {
                width: 100%;
                height: 347px;
                margin-top: 8px;
                ::v-deep .el-image__inner {
                  object-fit: contain;
                }
              }
            }
          }
          .pfname {
            margin: 15px 0px 0px 19px;
            display: flex;
            line-height: 24px;
            .pfjp {
              margin-left: 10px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #f86626;
              display: flex;
              img {
                width: 19px;
                height: 24px;
                margin-right: 10px;
                position: relative;
                top: 1px;
              }
              span {
                height: 29px;
              }
              .block {
                margin-left: 10px;
                display: flex;
              }
            }
          }
          h5 {
            min-width: 100px;
            line-height: 30px;

            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
          }
        }
        .details-right {
          padding: 15px;
          width: 347px;
          // height: 434px;
          background: #ffffff;
          border: 1px solid #ededed;
          .right-top {
            display: flex;
            height: 28px;
            .el-button {
              padding: 0px;
              width: 99px;
              height: 28px;
              background: #4ccaff;
              border-radius: 6px;
              background: #4ccaff;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              border-color: #4ccaff;
            }

            .el-button:hover {
              background: #4ccaffc9;
            }
            .right-top-x {
              color: #999999;
              line-height: 28px;
              // margin-left: 27px;
              margin-right: 25px;
              .lheight {
                position: relative;
                top: 2px;
              }
            }
            .scsadsa {
              color: #4ccaff;
              line-height: 28px;
              margin-left: 27px;
              margin-right: 25px;
              .lheight {
                position: relative;
                top: 2px;
              }
            }
            .right-top-y {
              color: #999999;
              line-height: 28px;
              .lheight {
                position: relative;
                top: 2px;
              }
            }
          }
          h4 {
            height: 15px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            margin-top: 25px;
            margin-bottom: 19px;
          }
          .nameofthe {
            font-size: 13px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 23px;
            margin-bottom: 2px;
          }
          .imgsd {
            .img {
              width: 19px;
              height: 19px;
              border-radius: 50%;
            }
            span {
              margin-left: 10px;
              font-size: 13px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 23px;
            }
          }
          .clsm {
            font-size: 13px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
            line-height: 23px;
            font-size: 13px;
          }
        }
      }
      .hss5 {
        height: 22px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        margin-top: 25px;
        margin-bottom: 18px;
      }
    }
  }
  #images {
    img {
      max-width: 646px;
      max-height: 363px;
    }
  }
  .pbbu {
    width: 98vw;
    ul {
      li {
        width: 45vw;
        height: 240px;
        margin-right: 10px;
        .Thetitle {
          padding: 9px 5px 0px 5px;
          .Thetitle-top {
            p {
              width: 140px;
            }
          }
        }
      }
    }
  }
  .Thetitle-center {
    margin-top: 5px;
  }
  .Thetitle-bottom {
    margin-top: 5px;
    padding: 5px 0;
    .Photoname {
      span {
        width: 80px;
      }
    }
  }

  .Materiaupload {
    position: fixed;
    top: 18rem;
    right: 1rem;
    z-index: 1;
  }

  .Figuremove {
    width: 45vw;
    height: 151px;
  }
  .el-pagination {
    ::v-deep span {
      padding: 0 5px;
    }
  }
}
</style>
